export const FontEnum = {
    TITILIUM_WEB: "Titillium Web"
}